import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
// import InAppBrowserEscaper, { InAppBrowserDetector } from '@jhrunning/inappbrowserescaper'
import './styles/index.css'
import App from './app/App'
import { applySteleDeviceAttribute, parseSvidQuery } from './utils/svidQuery'
import { preloadImages } from './utils/preloadImages'
import { initMatomo } from './utils/matomo'
import { startThreeDAssetPreload } from './game/preloadAssets'

const LIFERUSH_URL = 'https://liferush.de/'

// send inApp browsers to the default browser
// if (InAppBrowserDetector.isInAppBrowser()) {
//   InAppBrowserEscaper.escape({
//     fallbackUrl: LIFERUSH_URL,
//   })
// }

// reflect to html to avoid flashing
applySteleDeviceAttribute(parseSvidQuery(window.location.search).isPresent)
preloadImages()

// custom asset preload before first render
startThreeDAssetPreload()

initMatomo()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
